export const opacityMatrix = {
    left: [
        [1.0, 1.0, 1.0],
        [1.0, 0.8, 1.0],
        [0.8, 0.6, 1.0],
        [0.6, 0.4, 0.8],
        [0.4, 0.2, 0.6],
        [0.6, 0.4, 0.8],
        [0.8, 0.6, 1.0],
        [1.0, 0.8, 1.0],
        [1.0, 1.0, 1.0],

    ],
    right: [
        [1.0, 1.0, 1.0],
        [0.8, 1.0, 1.0],
        [0.6, 0.8, 1.0],
        [0.4, 0.6, 0.8],
        [0.2, 0.4, 0.6],
        [0.4, 0.6, 0.8],
        [0.6, 0.8, 1.0],
        [0.8, 1.0, 1.0],
        [1.0, 1.0, 1.0],
    ]
};